export default function formatPrice(num) {
  if (!num) return 0;
  else return Math.round(Number(num)).toLocaleString("en-IN");
}
